export default "__VITE_ASSET__BR$a_$To__"